import { Typography } from "@mui/material";
import {
  ReferenceInput,
  required,
  SelectInput,
  SelectInputProps,
  useTranslate,
} from "react-admin";

interface LocationSelectInputProps
  extends Omit<SelectInputProps, "source" | "choices"> {
  source: string;
  cityId: string | null | undefined;
  label?: string;
  isRequired?: boolean;
}

export const LocationSelectInput = (props: LocationSelectInputProps) => {
  const {
    source,
    cityId,
    label = "Location",
    isRequired = false,
    ...rest
  } = props;
  const translate = useTranslate();

  if (!cityId) {
    return (
      <Typography variant="body2" color="textSecondary" sx={{ mt: 2, mb: 1 }}>
        {translate("ra.gameoo.locationSelectPlaceholder")}
      </Typography>
    );
  }

  const validate = isRequired ? [required()] : undefined;

  return (
    <ReferenceInput
      source={source}
      reference="locations"
      label={label}
      filter={{ cityId: cityId }}
      key={cityId}
    >
      <SelectInput
        optionText="name"
        resettable
        fullWidth
        validate={validate}
        {...rest}
      />
    </ReferenceInput>
  );
};
